import React from "react";
import { Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { IHealthHubPlaylistVideo } from "@/models/ApiRequestResponse/patient";

import style from "./index.module.css";

type LongThumbnailCardProps = {
  video: IHealthHubPlaylistVideo;
};

const LongThumbnailCard: React.FC<LongThumbnailCardProps> = ({ video }) => {
  const navigate = useNavigate();

  const handleNavigate = () =>
    navigate(`/health-hub/video?videoId=${video.id}`);

  return (
    <Grid className={style.outerContainer} onClick={handleNavigate}>
      <img
        src={video.thumbnailUrl}
        alt={video.name}
        className={style.thumbnail}
      />
      <Typography variant="h6" className={style.title}>
        {video.name}
      </Typography>
    </Grid>
  );
};

export default LongThumbnailCard;
